import { useNavigate } from '@tanstack/react-router';
import { useScoringStatusQuery } from '@/api/pickems/getScoringStatus';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Loader2 } from 'lucide-react';

export function GlobalScoringBanner() {
  const navigate = useNavigate();
  const { data: status } = useScoringStatusQuery(5000); // Poll every 5 seconds

  if (!status?.isScoring) {
    return null;
  }

  const handleClick = () => {
    if (status.pickemId) {
      navigate({
        to: '/dashboard/pickems/$id',
        params: { id: status.pickemId },
        search: { league_id: undefined },
      });
    }
  };

  const locationText = status.pickemLocation ? ` (${status.pickemLocation})` : '';

  return (
    <Alert
      className="rounded-none border-x-0 border-t-0 bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-800 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900 transition-colors"
      onClick={handleClick}
    >
      <Loader2 className="h-4 w-4 animate-spin" />
      <AlertDescription className="flex items-center gap-2">
        <span className="font-medium">
          Currently scoring: {status.pickemName}
          {locationText}
        </span>
        {status.progress && (
          <span className="text-sm text-muted-foreground">
            ({status.progress.current.toLocaleString()} of {status.progress.total.toLocaleString()}{' '}
            - {status.progress.percentage}%)
          </span>
        )}
      </AlertDescription>
    </Alert>
  );
}
